<template>
  <div style="width: 50vw;">
    <div class="tertiary--text text-body-2">
      {{ 
        $t(
        'fleet_management.agents.agent_detail.partials.card_field_zones'
        )
      }}
    </div>
    <div class="mt-2 mb-2" v-if="!editMode">
      <div v-if="loading" class="text-left">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-chip v-for="(item, index) in selectedGeofence"
              :key="index"
              class="mr-2 mb-2"
              v-if="index < zonesToShow">
          {{ item.properties.name }}
      </v-chip>
      <span class="secondary--text mr-2" 
            v-if="zonesToShow < selectedGeofence.length && zonesToShow <= 10">
        ( {{ selectedGeofence.length  }} zonas en total )
      </span>
      <span class="secondary--text mr-2" 
            v-if="zonesToShow < selectedGeofence.length && zonesToShow > 10"
      >
        ( +{{ selectedGeofence.length - zonesToShow }} )
      </span>
      <v-btn small color="primary" text v-on="$listeners"
            v-if="zonesToShow < selectedGeofence.length" 
            @click="showMoreZones">
        <v-icon left >
          mdi-plus-circle-outline
        </v-icon>
        <span class="text-capitalize text-body-2">
          {{ 
            $t(
            'fleet_management.agents.agent_detail.partials.see_more'
            )
          }}
        </span>
      </v-btn>
    </div>
    <v-autocomplete
      v-if="editMode"
      id="idEventosZonas"
      v-model="selectedGeofence"
      :items="geofences"
      return-object
      :loading="loading"
      :disabled="loading"
      :readonly="!editMode"
      item-text="properties.name"
      deletable-chips
      hide-details="auto"
      required
      filled
      chips
      dense
      multiple
      color="tertiary"
      :rules="geofenceRules"
      no-data-text="No hay informacion"
      @input="geofenceEmit"
    >
      <template v-slot:prepend-item>
        <v-list-item ripple @click="selectAll">
          <v-list-item-action id="idEventosSeleccionarTodasLasZonas">
            <v-icon>
              {{ icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ 
                $t(
                'fleet_management.agents.agent_detail.partials.form_title_select_all'
                )
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:item="data" style="max-height: 50px;">
        <v-checkbox v-model="data.item.checked" :value="data.item.checked"></v-checkbox>
        <span
          :id="data.item.domElementId"
          @click="data.item.checked = !data.item.checked"
          class="dropdown-element-style py-6"
        >
          {{ data.item.properties.name }}
        </span>
      </template>
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index < 3">
          <span>{{ item.properties.name }}</span>
        </v-chip>
        <span v-else-if="index === 3" class="grey--text caption">
          (+{{ selectedGeofence.length - 3 }})
        </span>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { GeofencesHelpers } from '@/helpers/mainExports.js'
import { mapGetters } from 'vuex'

export default {
  name: 'inGeofence',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    dataProp: {
      default: []
    }
  },
  components: {},
  data() {
    return {
      loading: true,
      geofences: [],
      selectedGeofence: [],
      geofenceRules: [v => v.length > 0 || 'Campo Obligatorio'],
      zonesToShow: 10,
    }
  },
  methods: {
    showMoreZones() {
      this.zonesToShow += 10
    },
    async getGeofencesList() {
      this.loading = true
      const response = await GeofencesHelpers.getGeofences()
      this.loading = false
      if (!response.hasOwnProperty('error')) {
        const zones = response.map(item => {
          item.data.id = item.id
          return item.data
        })
        this.geofences = zones
        for (let index = 0; index < this.geofences.length; index++) {
          this.geofences[index]["domElementId"] = `idEventosZona${index}`
        }
        this.loading = false
      }
    },
    geofenceEmit() {
      const formGeofence = this.selectedGeofence
      const geofences = {}
      for (let index = 0; index < formGeofence.length; index++) {
        const element = formGeofence[index]
        const id = element.id
        const name = element.properties.name
        geofences[id] = name
      }

      this.dataProp = formGeofence
      this.$emit('geofenceEmit', this.dataProp)
    },
    selectAll() {
      if (!this.selectedGeofence.length) {
        this.selectedGeofence = this.geofences
        this.selectedGeofence.forEach(element => {
          element.checked = true
        })
      } else {
        this.selectedGeofence.forEach(element => {
          element.checked = false
        })
        this.selectedGeofence = []
      }
      this.geofenceEmit()
    }
  },
  computed: {
    ...mapGetters('auth', ['connection']),

    icon() {
      let iconName

      if (this.selectedGeofence.length === this.geofences.length) {
        iconName = 'mdi-close-box'
      } else if (this.selectedGeofence.length > 0) {
        iconName = 'mdi-minus-box'
      } else {
        iconName = 'mdi-checkbox-blank-outline'
      }

      return iconName
    }
  },
  watch: {
    editMode() {
      if (this.editMode == false) {
        this.selectedGeofence.forEach(element => {
          element.checked = false
        })
        this.selectedGeofence = []
        this.dataProp.map(item => {
          const id = Object.keys(item)[0]
          const data = this.geofences.find(geofence => geofence.id === id)
          data.checked = true
          this.selectedGeofence.push(data)
        })
      }
    }
  },
  created() {
    const connection = this.connection
    if (!connection.session.isOpen) {
      setTimeout(() => {
        this.$nextTick(function() {
          this.getGeofencesList().then(() => {
            this.dataProp.map(item => {
              const id = Object.keys(item)[0]
              const data = this.geofences.find(geofence => geofence.id === id)
              data.checked = true
              this.selectedGeofence.push(data)
            })
          })
        })
      }, 1000)
    } else {
      this.getGeofencesList().then(() => {
        this.dataProp.map(item => {
          const id = Object.keys(item)[0]
          const data = this.geofences.find(geofence => geofence.id === id)
          data.checked = true
          this.selectedGeofence.push(data)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-element-style {
  color: #2B2B2B;
  font-family: Lato, sans-serif;
  font-size: 13px;
  width: 100%;
}
</style>
